import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import {
  getPublishedAgronomyReferenceSheets,
  getPublishedBlanks,
  getPublishedTechSheets,
  getBrandings,
  getCoverImages,
  getPosterImages,
  getCropDividers,
  getFillerImages,
  getSeedCategories,
  getSeeds,
  getSeedIcons,
  getCrops,
  getDisclaimers,
  getLogos,
  getSeedDividers,
  getShelfDividers,
  getPostcardImages,
  getTaglines,
  login,
  status,
} from '../../actions/actions';
import { getStatuses } from '../../actions/orderActions';
import { IUserData } from '../../infrastructure/interfaces';
import { getHomePageRoute } from '../../infrastructure/HomePageRoute'

export interface ILoginProps {
  status(): void;
  login(data: any): void;
  getCrops(): void;
  getBrandings(): void;
  getCoverImages(): void;
  getPosterImages(): void;
  getDisclaimers(): void;
  getLogos(): void;
  getCropDividers(): void;
  getFillerImages(): void;
  getPublishedAgronomyReferenceSheets(): void;
  getPublishedBlanks(): void;
  getPublishedTechSheets(): void;
  getPostcardImages(): void;
  getSeedCategories(): void;
  getSeeds(): void;
  getSeedIcons(): void;
  getSeedDividers(): void;
  getShelfDividers(): void;
  getStatuses(): void;
  getTaglines(): void;
  userData: IUserData;
  isBusy: boolean;
  loginFailed: boolean;
  storedRoute: string;
}

export interface ILoginState {
  username: string;
  password: string;
  warningMessage: string;
}

@(connect(
  (state: any) => ({
    userData: state.user.data,
    loginFailed: state.user.loginFailed,
    storedRoute: state.storedRoute.storedRoute,
  }),
  {
    status,
    login,
    getCrops,
    getBrandings,
    getCoverImages,
    getPostcardImages,
    getPosterImages,
    getDisclaimers,
    getFillerImages,
    getLogos,
    getPublishedAgronomyReferenceSheets,
    getPublishedBlanks,
    getPublishedTechSheets,
    getStatuses,
    getCropDividers,
    getSeedCategories,
    getSeedDividers,
    getShelfDividers,
    getSeeds,
    getSeedIcons,
    getTaglines,
  }
) as any)
export default class Login extends React.Component<ILoginProps, ILoginState> {
  constructor(props: ILoginProps) {
    super(props);

    this.state = {
      username: "",
      password: "",
      warningMessage: "Authentification failed",
    };
  }

  componentDidMount() {
    this.props.status();
  }

  componentWillUnmount() {
    const {
      getCrops,
      getBrandings,
      getCoverImages,
      getPosterImages,
      getDisclaimers,
      getFillerImages,
      getLogos,
      getPostcardImages, 
      getPublishedAgronomyReferenceSheets,
      getPublishedBlanks,
      getPublishedTechSheets,
      getStatuses,
      getCropDividers,
      getShelfDividers,
      getSeedCategories,
      getSeedDividers,
      getSeeds,
      getSeedIcons,
      getTaglines,
    } = this.props;

    getCrops();
    getBrandings();
    getCoverImages();
    getPostcardImages();
    getPosterImages();
    getDisclaimers();
    getFillerImages();
    getLogos();
    getPublishedAgronomyReferenceSheets();
    getPublishedBlanks();
    getPublishedTechSheets();
    getStatuses();
    getCropDividers();
    getSeedCategories();
    getSeedDividers();
    getShelfDividers();
    getSeeds();
    getSeedIcons();
    getTaglines();
  }

  render() {
    return (
      <div className="login-container">
        {this.props.userData ? (
          <Redirect
            to={
              this.props.storedRoute
                ? this.props.storedRoute
                : getHomePageRoute(this.props.userData.role)
            }
          />
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Login/Login.tsx